import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=0847b74f&scoped=true&lang=html&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847b74f",
  null
  
)

export default component.exports